import type { StacItem } from 'src/shared/state/api-slices/stacCatalogueEngineSlice';

/**
 * What to call a version on screen.
 *
 * The identifier is an address: fixed the moment the version is catalogued, and usually a date
 * rather than a name. A title is what a super user chose to call it and can be corrected after
 * the fact, so it is what a reader sees — with the identifier showing through where none was
 * given, since every version has one.
 */
export const versionName = (version: StacItem): string => {
    const title = version.properties?.title;
    return typeof title === 'string' && title.trim().length > 0 ? title : version.id;
};
